jQuery(document).ready(function( $ ) {
    if ($('body.v3-template').length > 0) {

        // Modal Stuff
        $('[data-action="reserve"]').click(function (e) {
            e.preventDefault();
            $('#reserveModal').addClass('show').show();
            $('body').addClass('modal-open');
            $('.modal-backdrop').show().addClass('in');
        });

        $('[data-action="more_amenities"]').click(function (e) {
            e.preventDefault();
            $('#more_amenities').addClass('show').show();
            $('body').addClass('modal-open');
            $('.modal-backdrop').show().addClass('in');
        });

        $('[data-dismiss=modal]').click(function () {
            $('.modal').removeClass('show').hide();
            $('body').removeClass('modal-open');
            $('.modal-backdrop').hide().removeClass('in');
        });

        // This stuff just build the mock

        if (window.location.href.indexOf("?promote-video") > -1) {
            var theVideo = $('#ctas video');
            var theBanner = $('<div class="hero flex-fill d-flex align-items-center" style="background: #999 url(https://www.anytimefitness.com/wp-content/uploads/2018/06/small-group-1024x683.jpg) no-repeat center center / cover; background-blend-mode: multiply"> </div>');

            $(theVideo).prependTo('#location').wrap('<div class="video-container"></div>');
            $('#location .hero').css('background', 'var(--violet-dark)');
            $(theBanner).prependTo('#ctas');
            /*
                        $('#location .hero').css('background', "").html('<div id="brand_lockup" class="p-5" style="position:relative; z-index:1">	<img class="img-responsive " src="https://anytimefitness.blob.core.windows.net/shared-assets/mocks/af/consumer/img/lockup-your-goals.svg" alt=""></div>		<div class=""><video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" class="embed-responsive-item">    <source src="https://www.anytimefitness.com/wp-content/uploads/2020/02/AF_Video-Banner_OptionA_3MB.mp4" type="video/mp4">  </video></div>');

                        $('#ctas video').append('<div class="hero flex-fill d-flex align-items-center headroom" style="background: #999 url(https://www.anytimefitness.com/wp-content/uploads/2018/06/small-group-1024x683.jpg) no-repeat center center / cover; background-blend-mode: multiply">	  </div>')
            */
        }

        $('[data-toggle="tooltip"]').tooltip();

        $('[data-action="toggle_plans"]').click(function () {
            var text = $(this).text(), showMoreText = $(this).data('showMore'),
                showFewerText = $(this).data('showFewer');
            $('#plans_overflow').slideToggle();
            $(this).text(text == showFewerText ? showMoreText : showFewerText);
        });

        // Cache selectors
        var topMenu = $("#location_menu"),
            // All list items
            menuItems = topMenu.find("a"),
            // Anchors corresponding to menu items
            scrollItems = menuItems.map(function () {
                var temp = $(this).attr("href");
                if (temp.indexOf('#') !== -1) {
                    var anchor_part = temp.split('#');
                    var item = $('#'+anchor_part[1]);
                }
                if (typeof item !== "undefined" && item.length) {
                    return item;
                }
            });
        // Bind to scroll
        jQuery("main.scroll-container").scroll(function () {
            var current = false;
            $(scrollItems).each(function () {
                //console.log( index + ": " + $( this ).text() );
                //jQuery("#location_menu a").removeAttr("style");
                if (isElementInViewportMenu(this) && !current) {
                    jQuery("#location_menu [href='#" + this.attr("id") + "']").attr("style", 'color: #DB7C00 !important');
                    current = true;
                } else {
                    jQuery("#location_menu [href='#" + this.attr("id") + "']").removeAttr("style");
                }
            });
            if (!isElementInViewportMenu(jQuery("#location_nav"))) {
                jQuery("#dropdownMenuButton").dropdown('hide');
            }
        });

        $("#location_menu a").click(function(e) {
            if (window.innerWidth < 768) {
                e.preventDefault();
                let location_nav_height = 0;
                let temp = $(this).attr("href");

                if (temp.indexOf('#') !== -1) {
                    var anchor_part = temp.split('#');
                    var item = $('#'+anchor_part[1]);
                }

                if (typeof item !== "undefined" && item.length) {
                    if (!$(this).closest("#location_nav").hasClass( "stick" ) && !$(this).closest("#location_nav").hasClass( "active" )) {
                        location_nav_height = $(this).closest("#location_nav").height() + 55;
                    }
                    $('html, body').animate({
                        scrollTop: item.offset().top - location_nav_height
                    }, 1);
                }
            }
        });

        $("a[href='#hours'], a[href='#horario']").click(function(e) {
            if (window.innerWidth < 768) {
                e.preventDefault();
                let location_nav_height = 0;
                let item = $($(this).attr("href"));

                if (typeof item !== "undefined" && item.length) {
                    if (!$("#location_nav").hasClass( "stick" ) && !$("#location_nav").hasClass( "active" )) {
                        location_nav_height = $("#location_nav").height() + 55;
                    }
                    $('html, body').animate({
                        scrollTop: item.offset().top - location_nav_height
                    }, 1);
                }
            }
        });
        // fix for elementor z-index
        jQuery("#location_nav").closest("section.elementor-section").attr("style", 'z-index: 4');
        jQuery("#dropdownMenuButton").removeAttr("style");
        jQuery("body").removeAttr("style");

        // fix for staff photo/bios widget
        $('body').append($('.modal-anytime'));
        $('.people-content, .staff-member').click(function () { // old template class and new
            $('#gymPeopleModal').addClass('show');
            $('.modal-backdrop.fade').addClass('in').css('opacity', '0.95');
        });

        $('p.connect-here-item').click(function () {
            window.location.href = $(this).find('a').attr("href");
        });
    }
});

function isElementInViewportMenu(el) {
    // special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }
    var rect = el.getBoundingClientRect();
    return (
        (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) && rect.top <= (window.innerHeight || document.documentElement.clientHeight))
        || (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
    );
}
